import set from 'lodash/set';

interface ResponsiveAssetConfig {
  label: string;
  name: string;
}

const responsiveAssetConfig = ({ label, name }: ResponsiveAssetConfig) => {
  return {
    label,
    name,
    description: 'Image URL and metadata',
    type: 'object',
    fields: [
      {
        type: 'image',
        label: 'Image Src',
        name: 'src',
        ui: {
          validate: (value: any, allValues: any, meta: any, field: any) => {
            if (value) {
              const i = new Image();
              const fieldRoot = field.name.replace(/\.src$/, '');
              i.onload = () => {
                set(allValues, `${fieldRoot}.width`, i.naturalWidth);
                set(allValues, `${fieldRoot}.height`, i.naturalHeight);
              };
              i.src = value;
            }
          }
        }
      },
      {
        name: 'width',
        label: 'Width',
        type: 'number',
        default: 0,
        ui: {
          component: () => null
        }
      },
      {
        name: 'height',
        label: 'Height',
        type: 'number',
        default: 0,
        ui: {
          component: () => null
        }
      },
      {
        type: 'boolean',
        label: 'Priority',
        name: 'priority'
      },
      {
        type: 'string',
        label: 'Alt Text',
        name: 'alt'
      },
      {
        type: 'number',
        label: 'Quality',
        name: 'quality'
      },
      {
        type: 'string',
        label: 'Blur effect (placeholder)',
        name: 'placeholder',
        component: 'select',
        options: [
          { value: 'empty', label: 'empty' },
          { value: 'blur', label: 'blur' }
        ]
      },
      {
        type: 'string',
        label: 'Blur base64',
        name: 'blurDataURL',
        ui: {
          component: 'textarea'
        }
      },
      {
        type: 'string',
        label: 'Object Fit',
        name: 'objectFit',
        component: 'select',
        default: 'none',
        options: [
          { value: 'contain', label: 'contain' },
          { value: 'cover', label: 'cover' },
          { value: 'fill', label: 'fill' },
          { value: 'none', label: 'none' }
        ]
      },
      {
        label: 'Border Radius',
        name: 'borderRadius',
        type: 'number',
        description: 'value in px'
      },
      {
        label: 'Max height for mobile',
        name: 'maxHeightMobile',
        type: 'boolean',
        description: 'Values are in vh'
      },
      {
        type: 'boolean',
        label: 'Horizontal padding',
        name: 'horizontalPadding',
        description:
          'Only mobile if not in responsiveAsset. Default is false, if true it adds the same padding as on the text'
      }
    ]
  };
};

export default responsiveAssetConfig;
